import * as React from "react";
import { calendarReducer } from "./reducer";
import { CalendarState, getCalendarInicialState } from "./utils";
import { CalendarAction } from "./reducer";

const CalendarStateContext = React.createContext<CalendarState | undefined>(
  undefined
);
const CalendarDispatchContext = React.createContext<
  React.Dispatch<CalendarAction> | undefined
>(undefined);

interface CalendarProviderProps {
  children: React.ReactNode;
}

const CalendarProvider: React.FC<CalendarProviderProps> = ({ children }) => {
  const initialState = React.useMemo(() => getCalendarInicialState(), []);

  const [state, dispatch] = React.useReducer(calendarReducer, initialState);
  return (
    <CalendarStateContext.Provider value={state}>
      <CalendarDispatchContext.Provider value={dispatch}>
        {children}
      </CalendarDispatchContext.Provider>
    </CalendarStateContext.Provider>
  );
};

const useCalendarState = () => {
  const context = React.useContext(CalendarStateContext);
  if (context === undefined) {
    throw new Error("useCalendarState must be used within a CalendarProvider");
  }
  return context;
};

const useCalendarDispatch = () => {
  const context = React.useContext(CalendarDispatchContext);
  if (context === undefined) {
    throw new Error(
      "useCalendarDispatch must be used within a CalendarProvider"
    );
  }
  return context;
};

export { CalendarProvider, useCalendarDispatch, useCalendarState };
